export const POPOVER_CONTENT_CLASS = 'w-[var(--radix-popover-trigger-width)] min-w-72 p-0';

// Trigger and popover search input are both h-9 (36px). Offsetting the popover up by this height
// lands the search box on top of the trigger, so the dropdown appears to morph into it.
export const TRIGGER_HEIGHT_PX = 36;

// Opacity only, so the popover never renders narrower than the field mid-animation.
export const FADE_ONLY_MOTION = {
  initial: { opacity: 0 },
  animate: { opacity: 1 },
  exit: { opacity: 0 },
} as const;

export const OVERLAP_GRID = 'grid grid-cols-1';
export const OVERLAP_CELL = 'col-start-1 row-start-1';

export const TRANSITION_OPEN = 'duration-300 ease-[cubic-bezier(0.4,0,0.2,1)]';
export const TRANSITION_CLOSE = 'duration-[500ms] ease-[cubic-bezier(0.32,0.72,0,1)]';
